import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import translate from "../../../i18n/translate";
import "./PageNotFound.scss";

const PageNotFound: FunctionComponent = () => {
    return (
        <div className="PageNotFound-Container">
            <div className="ErrorMessage">
                <div>
                    <img                   
                        src={window.location.origin + "/images/errorPage/error-img.png"}
                        alt="ErrorPage Illustration"
                        title="ErrorPage Illustration"
                    />
                </div>
                <div>
                    {/* <h1>404</h1> */}
                    <h4>404 {translate("error_not_found")}</h4>
                    <p>{translate("noAccessl2")} <Link to="/">{translate("error_link_home")}</Link>.</p>
                    <p>{translate("error_contact_csm")}</p>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;
